import React, { Component } from 'react';
import logo from './../data-broker-logo-white.gif'; // Tell Webpack this JS file uses this image

class StepIndicator extends Component {
  render() {
    const { currentStep, steps } = this.props
    console.log("currentStep = "+currentStep)
    let items = []
    Object
      .keys(steps)
      .map( (key, index) => {
        let classList = ``
        if(currentStep == index+1)
          classList = `active`

        if(currentStep > index+1)
          classList = `active complete`

        items.push(
          <span onClick={ (e) => { this.props.stepChange(index+1) } } key={ key } className={ classList }>{ index+1 }. { steps[key]['label'] }</span>
        )
    })

    return (
      <nav className="step-indicator">
        { items }
      </nav>
    )
  }
}

export default StepIndicator
